import { Box, Spinner } from "@chakra-ui/react"
import { motion } from "framer-motion"
import { useCoverPageContext } from "./CoverPageProvider"

const CoverPageLoadingOverlay = () => {
  const { loadingNextCoverPage } = useCoverPageContext()

  if (!loadingNextCoverPage) {
    return null
  }

  return (
    <motion.div
      className="CoverPageLoadingOverlay"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.2 }}
      style={{
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 1111111,
        pointerEvents: "none"
      }}
    >
      <Box
        position="absolute"
        top={0}
        left={0}
        right={0}
        bottom={0}
        bgColor="whiteAlpha.200"
        backdropFilter="blur(10px)"
        display="flex"
        alignItems="center"
        justifyContent="center"
        borderRadius="card"
        overflow="hidden"
      >
        <Spinner size="lg" color="blackAlpha.600" borderWidth="3px" />
      </Box>
    </motion.div>
  )
}

export default CoverPageLoadingOverlay
